import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'gdp-confirmation-alphaname-popup',
  templateUrl: './confirmation-alphaname-popup.component.html',
  styleUrls: ['./confirmation-alphaname-popup.component.scss']
})
export class ConfirmationAlphanamePopupComponent implements OnInit {
  public form: UntypedFormGroup;
  public message: string;
  public alphaname: string;
  public params: Record<string, string> = {};

  constructor(
    private activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      alphaname: new UntypedFormControl('', [Validators.required, this.isInvalid()] )
    });
  }

  isInvalid() {
    return (control:UntypedFormControl) => {
      return this.alphaname != control.value
        ? { mismatch: true }
        : null;
    }
  }

  close() {
    this.activeModal.close('close');
  }

  ok() {
    this.activeModal.close('ok');
  }
}
